import { HStack } from '@astryxdesign/core/HStack';
import { StatusDot } from '@astryxdesign/core/StatusDot';
import { Text } from '@astryxdesign/core/Text';

/** A status dot with its meaning written next to it (StatusDot alone only exposes the label to screen readers). */
export function StatusLine({ variant, label, size = 'sm' }: { variant: 'success' | 'warning' | 'error' | 'accent' | 'neutral'; label: string; size?: 'xsm' | 'sm' | 'base' }) {
  return (
    <HStack gap={1.5} align="center">
      <StatusDot variant={variant} label={label} />
      <Text size={size} color="secondary" aria-hidden>{label}</Text>
    </HStack>
  );
}
